<ng-container *ngTemplateOutlet="mode === 'home' ? homefilter : nohomefilter"></ng-container>

<ng-template #homefilter>
    <ng-container [ngSwitch]="media">
        <ng-container *ngSwitchCase="'xs'" [ngTemplateOutlet]="homemodeMobile"></ng-container>
        <ng-container *ngSwitchCase="'sm'" [ngTemplateOutlet]="homemodeMobile"></ng-container>
        <ng-container *ngSwitchDefault [ngTemplateOutlet]="homefilterdesk"></ng-container>
    </ng-container>
</ng-template>

<ng-template #homefilterdesk>
    <button class="tmpbtn w100 tmp-right" #mdbuttondesk="cdkOverlayOrigin" cdkOverlayOrigin
        (click)="openModal($event)" [matTooltip]="zielText" matRipple>
        <mat-icon fontIcon="person"></mat-icon>
        <span class="ellipsis">{{zielText}}</span>
    </button>
    <ng-template cdkConnectedOverlay [cdkConnectedOverlayOrigin]="mdbuttondesk"
        [cdkConnectedOverlayFlexibleDimensions]="true" [cdkConnectedOverlayOpen]="showModal"
        [cdkConnectedOverlayHasBackdrop]="true" (backdropClick)="closeModal()">
        <ng-container *ngTemplateOutlet="modal"></ng-container>
    </ng-template>
</ng-template>

<ng-template #homemodeMobile>
    <button class="tmpbtn w100 tmp-rightmobile" #mdbuttonMobile="cdkOverlayOrigin" cdkOverlayOrigin
        (click)="openModalMobile($event)" matRipple>
        <mat-icon fontIcon="person"></mat-icon>
        <span class="ellipsis">{{zielText}}</span>
    </button>
    <ng-template cdkConnectedOverlay [cdkConnectedOverlayOrigin]="mdbuttonMobile"
        [cdkConnectedOverlayFlexibleDimensions]="true" [cdkConnectedOverlayOpen]="showModal"
        [cdkConnectedOverlayHasBackdrop]="true" (backdropClick)="closeModalMobile()">
        <ng-container *ngTemplateOutlet="modal"></ng-container>
    </ng-template>
</ng-template>

<ng-template #nohomefilter>
    <ng-container *ngIf="mode === 'nohomesmall' else mbfilters">
        {{zielText }}
    </ng-container>
</ng-template>
<ng-template #mbfilters>
    <button class="tmpbtn w100 tmp-rightmobile" #mdbuttonMobile="cdkOverlayOrigin" cdkOverlayOrigin
        (click)="openModalMobile($event)" matRipple>
        <mat-icon fontIcon="person"></mat-icon>
        <span class="ellipsis">{{zielText}}</span>
    </button>
    <ng-template cdkConnectedOverlay [cdkConnectedOverlayOrigin]="mdbuttonMobile"
        [cdkConnectedOverlayFlexibleDimensions]="true" [cdkConnectedOverlayOpen]="showModal"
        [cdkConnectedOverlayHasBackdrop]="true" (backdropClick)="closeModalMobile()">
        <ng-container *ngTemplateOutlet="modal"></ng-container>
    </ng-template>
</ng-template>

<ng-template #modal>
    <ng-container [ngSwitch]="media">
        <ng-container *ngSwitchCase="'xs'" [ngTemplateOutlet]="mobileModal"></ng-container>
        <ng-container *ngSwitchCase="'sm'" [ngTemplateOutlet]="mobileModal"></ng-container>
        <ng-container *ngSwitchDefault [ngTemplateOutlet]="mobileDesk"></ng-container>
    </ng-container>
</ng-template>

<ng-template #mobileDesk>
    <div class="backdropwrapper mat-elevation-z1" [@zoom]="origin">
        <div class="filterwrapper">
            <ng-container *ngTemplateOutlet="datassection"></ng-container>
        </div>
    </div>
</ng-template>

<ng-template #mobileModal>
    <div class="backdropwrapper-mobile" [@zoom]="origin">
        <div class="filterwrapper-mobile">
            <div class="f-headerwrapper">
                <button matRipple (click)="closeModalMobile()">
                    <mat-icon class="btnico-mobile">arrow_back</mat-icon>
                </button>
            </div>
            <ng-container *ngTemplateOutlet="datassection"></ng-container>
        </div>
    </div>
</ng-template>

<ng-template #datassection>
    <div class="f-bodywrapper customscroll">
        <div class="cc3">
            <span class="cc6">Erwachsene</span>
            <div class="cc4">
                <button matRipple class="cc5" (click)="removeAdult()"><mat-icon>remove</mat-icon></button>
                <div class="cc6">{{ferienFiltersService.adults}}</div>
                <button matRipple class="cc5" (click)="addAdult()"><mat-icon>add</mat-icon></button>
            </div>
        </div>
        <div class="cc3">
            <span class="cc6">Kinder</span>
            <div class="cc4">
                <button matRipple class="cc5" (click)="removeChildren()"><mat-icon>remove</mat-icon></button>
                <div class="cc6">{{ferienFiltersService.children}}</div>
                <button matRipple class="cc5" (click)="addChildren()"><mat-icon>add</mat-icon></button>
            </div>
        </div>
        @if(ferienFiltersService.childrenAges?.length > 0) {
            <div class="cc9">
                @for (item of ferienFiltersService.childrenAges; let k=$index; track k) {
                 <select class="cc8" [(ngModel)]="ferienFiltersService.childrenAges[k]">
                     <option value="-1">Alter {{k + 1}}</option>
                     @for (ag of ages; track $index) {
                         <option [value]="ag">{{ag === 1 ? ag + ' Jahr alt' : ag + ' Jahre alt'}}</option>
                     }
                 </select>
                }
            </div>
        }
        <div class="cc3">
            <button class="cc7" (click)="selectReisendes()">ANWENDEN</button>
        </div>
    </div>
</ng-template>